// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ILetterOfMedicalNecessityClaimDto } from './ILetterOfMedicalNecessityClaimDto';
import {
    ILetterOfMedicalNecessityClaimDtoFromJSON,
    ILetterOfMedicalNecessityClaimDtoFromJSONTyped,
    ILetterOfMedicalNecessityClaimDtoToJSON,
    ILetterOfMedicalNecessityClaimDtoToJSONTyped,
} from './ILetterOfMedicalNecessityClaimDto';

/**
 * 
 * @export
 * @interface ILetterOfMedicalNecessityDto
 */
export interface ILetterOfMedicalNecessityDto {
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityDto
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityDto
     */
    document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Array<ILetterOfMedicalNecessityClaimDto>}
     * @memberof ILetterOfMedicalNecessityDto
     */
    claims?: Array<ILetterOfMedicalNecessityClaimDto>;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityDto
     */
    created_at?: Date;
}

/**
 * Check if a given object implements the ILetterOfMedicalNecessityDto interface.
 */
export function instanceOfILetterOfMedicalNecessityDto(value: object): value is ILetterOfMedicalNecessityDto {
    return true;
}

export function ILetterOfMedicalNecessityDtoFromJSON(json: any): ILetterOfMedicalNecessityDto {
    return ILetterOfMedicalNecessityDtoFromJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILetterOfMedicalNecessityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'claims': json['claims'] == null ? undefined : ((json['claims'] as Array<any>).map(ILetterOfMedicalNecessityClaimDtoFromJSON)),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function ILetterOfMedicalNecessityDtoToJSON(json: any): ILetterOfMedicalNecessityDto {
    return ILetterOfMedicalNecessityDtoToJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityDtoToJSONTyped(value?: ILetterOfMedicalNecessityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'document_id': value['document_id'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'claims': value['claims'] == null ? undefined : ((value['claims'] as Array<any>).map(ILetterOfMedicalNecessityClaimDtoToJSON)),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

